import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UtmModel } from '@shared/models/interfaces/utmModel.interface';

@Injectable({
  providedIn: 'root',
})
export class UtmService {
  constructor(private http: HttpClient) {}

  private webhookUrl = 'https://hook.integromat.com/gwr02gm990stpnpf1maq6hf2lt3e2thi' as const;
  private token = 'Bearer 076dd593ef4cd05e6148a79f3697c143' as const;

  private options = {
    headers: new HttpHeaders({
      Authorization: this.token,
    }),
  };

  sendWebhook(utmJson: UtmModel) {
    return this.http.post(this.webhookUrl, utmJson, this.options).toPromise();
  }
}
